import { render, staticRenderFns } from "./messageSignatures.vue?vue&type=template&id=c35aca20&"
import script from "./messageSignatures.vue?vue&type=script&lang=js&"
export * from "./messageSignatures.vue?vue&type=script&lang=js&"
import style0 from "./messageSignatures.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports